import { MockApiClient } from '@base/utils/mock-api'

export const useHealthStore = defineStore('health', () => {
  const isHealthy = ref(true) // 默认为健康状态

  async function fetchHealthCheck() {
    try {
      await MockApiClient.healthCheck()
      isHealthy.value = true
    }
    catch {
      isHealthy.value = false
    }
  }

  return {
    isHealthy,
    fetchHealthCheck,
  }
})
